module.exports = __webpack_public_path__ + "static/media/select_dark.a345ad50.svg";